import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
  registerLocaleData,
} from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { forwardRef, NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserModule } from "@angular/platform-browser";
import "hammerjs";
import { BlockUIModule } from "ng-block-ui";
import {
  RecaptchaModule,
  RecaptchaSettings,
  RECAPTCHA_SETTINGS,
} from "ng-recaptcha";
import { NgxHmCarouselModule } from "ngx-hm-carousel";
import { NgxMaskModule } from "ngx-mask";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { IdentityStorage } from "./auth/_models/identity.storage";
import { MaterialModule } from "./material.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ToastrModule } from "ngx-toastr";
import { NZ_I18N } from "ng-zorro-antd/i18n";
import { en_US } from "ng-zorro-antd/i18n";
import en from "@angular/common/locales/en";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AntdModule } from "./antd.module";

import { IconsProviderModule } from "./icons-provider.module";
import { InputMaskModule } from '@ngneat/input-mask';
import { LoadingInterceptor } from "./core/interceptors/loading/loading.interceptor";
import { SharedModule } from "./shared/shared.module";

registerLocaleData(en);

const globalSettings: RecaptchaSettings = {
  siteKey: "6Lc8vGwUAAAAAOsheXbsSd7qKpwLv0t2ECF1i___",
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    MatDialogModule,
    MatIconModule,
    BrowserModule,
    MaterialModule,
    AntdModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    NgxMaskModule,
    BlockUIModule,
    BlockUIModule.forRoot(),
    NgxHmCarouselModule,
    RecaptchaModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    IconsProviderModule,
    InputMaskModule,
    SharedModule
  ],
  providers: [
    IdentityStorage,
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: RECAPTCHA_SETTINGS, useValue: globalSettings },
    { provide: NZ_I18N, useValue: en_US },
  ],
  entryComponents: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
